import DeviceInterfaceTable from './DeviceInterfaceTable';
import DeviceAccessPointTable from './DeviceAccessPointTable';
import DeviceRadioTable from './DeviceRadioTable';
import DeviceMonitoringDiagnostics from './DeviceMonitoringDiagnostics';
import { useDeviceInfraContext } from './DeviceInfraContext';

/**
 * Conditionally renders table sections based on device type.
 * Hidden for new devices.
 * - Interface table: all types except server
 * - Access Points table: wirelesscontroller only
 * - Radios table: accesspoint only
 * - Monitoring Diagnostics: all existing devices
 */
export default function DeviceTablesSection() {
    const { isCreateAction, isServer, isAccessPoint, isWirelessController } = useDeviceInfraContext();

    if (isCreateAction) {
        return null;
    }

    return (
        <>
            {!isServer && <DeviceInterfaceTable />}
            {isWirelessController && <DeviceAccessPointTable />}
            {isAccessPoint && <DeviceRadioTable />}
            <DeviceMonitoringDiagnostics />
        </>
    );
}
